import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonArrowState,
  Loader,
  PrimaryButton,
  SecondaryButton
} from '@huggg/react-components';
import { Dialog } from 'components/ui';
import dictionary from 'config/dictionary';
import styles from './types.module.scss';

const MARKDOWN_LINK_URL_REGEX = /\[[^\]]*\]\s*\(\s*([^)]+)\s*\)/;

const getVirginExperienceUrl = description => {
  if (typeof description !== 'string' || !description.trim()) {
    return null;
  }
  const match = description.match(MARKDOWN_LINK_URL_REGEX);
  return match ? match[1].trim() : null;
};

const VirginExperienceFulfil = ({
  loading = false,
  onClick,
  onFulfil,
  redeemedSegment
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const experienceDetailsUrl = redeemedSegment?.description
    ? getVirginExperienceUrl(redeemedSegment.description)
    : null;

  const handleButtonClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    if (onFulfil && redeemedSegment) {
      onFulfil(redeemedSegment);
    } else if (onClick) {
      onClick();
    }
    setShowConfirmModal(false);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div
          className={styles.virginExperienceWrapper}
          data-test-id={JSON.stringify({
            experienceDetailsUrl,
            redeemedSegment
          })}
        >
          {experienceDetailsUrl && (
            <a
              className={styles.viewExperienceDetailsLink}
              href={experienceDetailsUrl}
              target="_blank"
              rel="noreferrer"
              data-test-id="view-experience-details-link"
            >
              {dictionary.virginExperiences.viewExperienceDetails}
            </a>
          )}
          <PrimaryButton
            onClick={handleButtonClick}
            data-test-id="button-visit-external"
            label="Click here to book"
            arrow={ButtonArrowState.None}
            loading={loading}
            className={styles.fulfilButton}
          />
        </div>
      )}

      <Dialog
        visible={showConfirmModal}
        onClose={handleCancel}
        disableOverlayClick
        showCloseButton={false}
        contentClassName={styles.confirmClaimContent}
        title={dictionary.virginExperiences.confirmTitle}
      >
        <div className={styles.confirmClaimButtons}>
          <PrimaryButton
            className={styles.confirmClaimConfirm}
            onClick={handleConfirm}
            data-test-id="confirm-claim-dialog-confirm"
            label={dictionary.virginExperiences.confirmButtonText.toUpperCase()}
          />
          <SecondaryButton
            onClick={handleCancel}
            label={dictionary.virginExperiences.cancelButtonText.toUpperCase()}
            arrow={ButtonArrowState.Backwards}
            className={styles.confirmClaimCancel}
            data-test-id="confirm-claim-dialog-cancel"
          />
        </div>
      </Dialog>
    </>
  );
};

VirginExperienceFulfil.propTypes = {
  onClick: PropTypes.func,
  onFulfil: PropTypes.func,
  loading: PropTypes.bool,
  redeemedSegment: PropTypes.object
};

export default VirginExperienceFulfil;
